var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactveMandal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(26 549)",
    fill: "#111a45"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(-26 -549)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_01-home",
    "data-name": "01-home",
    transform: "translate(31.268 552.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M10.827.206A7.741,7.741,0,0,0,3.1,7.938c0,2.071,1.255,4.731,3.729,7.9A42.044,42.044,0,0,0,10.5,19.957a.473.473,0,0,0,.654,0,42.045,42.045,0,0,0,3.675-4.114c2.475-3.174,3.729-5.834,3.729-7.9A7.741,7.741,0,0,0,10.827.206Zm0,13.255A5.523,5.523,0,1,1,16.35,7.938,5.529,5.529,0,0,1,10.827,13.461Z",
    transform: "translate(-3.095 -0.206)",
    fill: "#111a45"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "M",
    transform: "translate(39 563)",
    fill: "#111a45",
    fontSize: 9,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "M")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactveMandal);
export default __webpack_public_path__ + "static/media/inactveMandal.5e7b87019c52f79dd2053bd2982af9e8.svg";
export { ForwardRef as ReactComponent };